"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDispensa = void 0;
const enums_1 = require("../enums");
const getDispensa = (tipoDispensa) => {
    if (!tipoDispensa || tipoDispensa.trim() == '')
        return '';
    return (0, enums_1.getKeyFromValue)(enums_1.ETipoDispensa, tipoDispensa);
};
exports.getDispensa = getDispensa;
